/* Redirect legacy /spam-test to Form Builder Firewall tab */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SpamTestRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/form-builder?tab=spam-settings', { replace: true });
  }, [navigate]);

  return null;
}
